// extracted by mini-css-extract-plugin
module.exports = {"table":"FlexTable_table__1yq1M","head":"FlexTable_head__3h9ad","body":"FlexTable_body__38KLR","row":"FlexTable_row__2iaw7","cell":"FlexTable_cell__1TPzl"};